module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Lily-laughing-640.25d58360.png";